import { Col, Row } from "react-bootstrap";
import moment from "moment/min/moment-with-locales";
import { StarFill } from "react-bootstrap-icons";

export default function PredictorRow({ item, setCatalogueSong }) {
    const songBirth = item.song_birth ? moment(item.song_birth).format("L HH:mm") : "-";

    return (
        <Row className={`py-1 border-bottom hoverable`} onClick={() => setCatalogueSong(item.song)}>
            <Col xs={3} xl className=" align-content-center d-none d-xl-block">
                {item.song.artist}
            </Col>
            <Col xs={3} xl className=" align-content-center d-none d-xl-block">
                {item.song.title}
            </Col>
            <Col xs={12} className=" align-content-center d-xl-none">
                <Row className="gx-1">
                    <Col xs={"auto"} className=" align-items-center fs-5 d-flex me-1">
                        {Array(item.stars)
                            .fill()
                            .map((_, i) => (
                                <StarFill key={i} />
                            ))}
                    </Col>
                    <Col xs={"auto"}>
                        <span className="fw-bold fw-xl-normal">{item.song.artist}</span>
                    </Col>
                    <Col xs={"auto"}>
                        <span className="fw-bold fw-xl-normal">-</span>
                    </Col>
                    <Col xs={"auto"}>
                        <span className="fw-bold fw-xl-normal">{item.song.title}</span>
                    </Col>
                </Row>
            </Col>
            <Col xs={"auto"} xl={2} className=" align-content-center text-center">
                <span className=" d-xl-none">Song Birth: </span>
                <span className=" fw-bold fw-xl-normal">{songBirth}</span>
            </Col>
            <Col xs={"auto"} xl={2} className=" align-content-center text-center">
                <span className=" d-xl-none">Market Spins: </span>
                <span className=" fw-bold fw-xl-normal">{item.market_spins ?? "-"}</span>
            </Col>
            <Col xs={"auto"} xl={1} className=" align-items-center justify-content-center fs-6 d-none d-xl-flex">
                {Array(item.stars)
                    .fill()
                    .map((_, i) => (
                        <StarFill key={i} />
                    ))}
            </Col>
        </Row>
    );
}
